import { StateSchema } from 'app/config/storeConfig/types';

export const getSearch = (state: StateSchema): string | undefined => state.warehouseMap.search;
